import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: { id: 'Homepage rollover', defaultMessage: 'Homepage rollover' },
  items: { id: 'Rollover items', defaultMessage: 'Rollover items' },
  image: { id: 'Image', defaultMessage: 'Image' },
  itemTitle: { id: 'Title', defaultMessage: 'Title' },
  link: { id: 'Link', defaultMessage: 'Link' },
});

const RolloverItemSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.items),
  fieldsets: [
    { id: 'default', title: 'Default', fields: ['image', 'title', 'link'] },
  ],
  properties: {
    image: {
      title: intl.formatMessage(messages.image),
      widget: 'object_browser',
      mode: 'image',
      return: 'single',
      selectableTypes: ['unitatespecialitzada'],
      initialPath: '/serveis-medics/unitats-especialitzades',
      selectedItemAttrs: ['@type', 'title', 'image_field', 'image_scales'],
    },
    title: { title: intl.formatMessage(messages.itemTitle) },
    link: { title: intl.formatMessage(messages.link), widget: 'url' },
  },
  required: ['image', 'title', 'link'],
});

export const HomepageRolloverSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [{ id: 'default', title: 'Default', fields: ['items'] }],
  properties: {
    items: {
      title: intl.formatMessage(messages.items),
      widget: 'object_list',
      schema: RolloverItemSchema({ intl }),
    },
  },
  required: [],
});
